/**
 * Created by gavin on 19/2/15.
 */
import axios from "../../utils/axios";

// 意见反馈列表
export function getList(query) {
    return axios({
        url: "sysOpinionBack/getList",
        method: "get",
        params: query
    });
}

// 删除
export function delOpinionback(data) {
    return axios({
            url: "sysOpinionBack/delete",
        method: "post",
        data: data
    });
}

export function editOpinionback(data) {
    return axios({
            url: "sysOpinionBack/delete",
        method: "post",
        data: data
    });
}
